(function(){'use strict';function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var RoutineBuilder=function(){function e(){_classCallCheck(this,e),this.data=null,this.selectedBubbles=[],this.maxSelections=2,this.bubblesContainer=document.getElementById("routine-builder-bubbles"),this.productsContainer=document.getElementById("routine-builder-products"),this.cartSectionContainer=document.getElementById("routine-builder-cart-section"),this.addToCartButton=document.getElementById("routine-add-to-cart"),this.resizeTimer=null,this.mediaQuery=window.matchMedia("(max-width: 749px)"),this.bubbleFlkty=null,this.cart=document.querySelector("cart-notification")||document.querySelector("cart-drawer"),this.cartUpdateUnsubscriber=null,this.bubbleTemplate=document.getElementById("routine-builder-bubble-template"),this.productCardTemplate=document.getElementById("routine-builder-product-card-template"),this.errorWrapper=document.querySelector(".routine-builder-cart-actions .error__message"),this.bubblesContainer&&this.productsContainer&&this.cartSectionContainer?this.bubbleTemplate&&this.productCardTemplate?this.init():console.error("Routine Builder: Required templates not found"):console.error("Routine Builder: Required containers not found");}var t,r;return _createClass(e,[{key:"init",value:function(){var e=this,t=document.getElementById("routine-builder-data");if(t)try{this.data=JSON.parse(t.textContent),this.maxSelections=parseInt(this.bubblesContainer.dataset.maxSelections,10)||2,this.renderBubbles(),this.selectFirstBubbleByDefault(),this.renderProducts(),this.setupGlobalListeners(),this.setupCartUpdateSubscription(),this.addToCartButton&&this.addToCartButton.addEventListener("click",(function(){return e.addRoutineToCart()}));}catch(e){console.error("Routine Builder: Error parsing data",e);}else console.error("Routine Builder: Data script not found");}},{key:"renderBubbles",value:function(){var e=this;if(this.data&&this.data.bubbles){var t=document.createDocumentFragment();this.data.bubbles.forEach((function(r,a){var i=e.bubbleTemplate.content.cloneNode(!0),n=i.querySelector(".routine-builder-bubble--item"),o=i.querySelector("img"),s=i.querySelector(".routine-builder-bubble__title");n.dataset.bubbleId=r.id,n.dataset.bubbleIndex=a,o.dataset.regularImage=r.image.url,r.activeImage&&r.activeImage.url&&(o.dataset.activeImage=r.activeImage.url),o.src=r.image.url,o.alt=r.image.alt,s.textContent=r.title,n.addEventListener("click",(function(t){return e.handleBubbleClick(t)})),t.appendChild(i);})),this.bubblesContainer.appendChild(t),requestAnimationFrame((function(){e.handleBubbleSlider();}));}}},{key:"selectFirstBubbleByDefault",value:function(){if(this.data&&this.data.bubbles&&0!==this.data.bubbles.length){var e=this.data.bubbles[0],t=this.bubblesContainer.querySelector('[data-bubble-id="'.concat(e.id,'"]'));t&&(this.selectedBubbles.push(e),t.classList.add("is-active"),this.updateBubbleImage(t,!0));}}},{key:"updateBubbleImage",value:function(e,t){var r=e.querySelector("img");r&&this.bubblesContainer&&(t&&r.dataset.activeImage?r.src=r.dataset.activeImage:r.src=r.dataset.regularImage);}},{key:"handleBubbleClick",value:function(e){var t=e.currentTarget,r=parseInt(t.dataset.bubbleIndex,10),a=this.data.bubbles[r];if(a)if(t.classList.contains("is-active"))this.selectedBubbles.length>1&&(this.selectedBubbles=this.selectedBubbles.filter((function(e){return e.id!==a.id})),t.classList.remove("is-active"),this.updateBubbleImage(t,!1),this.renderProducts());else {if(this.selectedBubbles.length>=this.maxSelections){var i=this.selectedBubbles[0],n=this.bubblesContainer.querySelector('[data-bubble-id="'.concat(i.id,'"]'));n&&(n.classList.remove("is-active"),this.updateBubbleImage(n,!1)),this.selectedBubbles.shift();}this.selectedBubbles.push(a),t.classList.add("is-active"),this.updateBubbleImage(t,!0),this.renderProducts();}}},{key:"renderProducts",value:function(){var e=this;if(0!==this.selectedBubbles.length){this.productsContainer.classList.add("is-loading");var t=this.getProductsForSelectedBubbles();setTimeout((function(){try{e.productsContainer.innerHTML="";var r=document.createDocumentFragment();t.forEach((function(a,i){try{var n=e.createProductCardFromTemplate(a);if(n&&(r.appendChild(n),i<t.length-1)){var o=document.createElement("div");o.className="routine-builder-product-separator",o.innerHTML='\n                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n                    <rect width="28" height="28" rx="14" fill="#A6B4A7"/>\n                    <path d="M13.9681 8V20M8 13.8696H20" stroke="#EDF0ED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n                  </svg>',r.appendChild(o);}}catch(e){console.error("Error creating product card ".concat(i,":"),e);}})),e.productsContainer.appendChild(r),e.productsContainer.classList.remove("is-loading"),e.renderCartSection(t);}catch(t){console.error("Error in renderProducts setTimeout:",t),e.productsContainer.classList.remove("is-loading");}}),100);}else this.cartSectionContainer.classList.add("hidden");}},{key:"getProductsForSelectedBubbles",value:function(){if(!this.data.combinations||0===this.selectedBubbles.length)return [];var e=this.selectedBubbles.map((function(e){return e.id})).sort(),t=this.data.combinations.find((function(t){var r=t.bubbleIds.sort();return JSON.stringify(r)===JSON.stringify(e)}));if(!t){if(1===e.length){var r=this.data.combinations.filter((function(t){return t.bubbleIds.includes(e[0])&&t.products.length>0}));if(r.length>0)return r[0].products}if(this.data.combinations.length>0&&this.data.combinations[0].products.length>0)return this.data.combinations[0].products}return t?t.products:[]}},{key:"renderCartSection",value:function(e){var t;0!==e.length?(this.cartSectionContainer.classList.remove("hidden"),this.updateCartTotal(e),null===(t=this.errorWrapper)||void 0===t||t.classList.add("hidden")):this.cartSectionContainer.classList.add("hidden");}},{key:"updateCartTotal",value:function(e){var t=0,r=0,a=0,i=this.data.settings;e.forEach((function(e){e.price&&(t+=e.price),e.routinePrice&&e.routinePrice>0?a+=e.routinePrice:e.price&&(a+=e.price),e.compareAtPrice&&(r+=e.compareAtPrice);}));var n=document.querySelector("[data-routine-total-price]"),o=document.querySelector("[data-routine-discount-amount]"),s=document.querySelector("[data-routine-original-price]"),c=document.getElementById("routine-discount-price"),d=document.querySelector("#routine-builder-cart-section .price__regular"),u=document.querySelector("#routine-builder-cart-section .price__container"),l=document.querySelector("[data-sale-text-value]"),b=document.querySelector("[data-sale-text-wrapper]"),h=document.querySelector("[data-gift-product-price]"),p=function(e){return "".concat(i.currency).concat((e/100).toFixed(2).replace(".",","))},m=p(a||t||r);if(n&&(n.textContent=m),(a>0&&a<t||0===a&&r>0&&r>t)&&c){var g,f,v;a>0?(g=t,f=a,v=t-a):(g=r,f=t,v=r-t),h&&h.dataset.giftProductPrice&&(v+=parseFloat(h.dataset.giftProductPrice));var y=p(g),C=p(f),S=p(v);o&&(o.textContent=C),s&&(s.textContent=y),l&&(l.textContent=S),u&&u.classList.add("price--on-sale"),c.classList.remove("hidden"),d&&d.classList.add("hidden"),b&&b.classList.remove("hidden");}else u&&u.classList.remove("price--on-sale"),d&&d.classList.remove("hidden"),c&&c.classList.add("hidden"),b&&b.classList.add("hidden");}},{key:"addRoutineToCart",value:function(){var t,r=this;if("true"!==this.addToCartButton.getAttribute("aria-disabled")){this.addToCartButton.setAttribute("aria-disabled",!0),this.addToCartButton.classList.add("loading"),this.addToCartButton.querySelector(".loading__spinner").classList.remove("hidden"),null===(t=this.errorWrapper)||void 0===t||t.classList.add("hidden");var a=this.getProductsForSelectedBubbles();if(0!==a.length){var i=e.generateRoutineId(),n=[];a.forEach((function(e){n.push({id:e.firstVariantId,quantity:1,properties:{_routine_id:i,_price:e.price,_routine_length:a.length}});}));var o=document.querySelector(".routine-builder-gift-price");if(o){var s=o.dataset,c=s.giftProductId,d=s.giftProductPrice;c&&n.push({id:parseInt(c,10),quantity:1,properties:{_routine_id:i,_price:parseFloat(d),_is_gift:"true",_routine_length:a.length}});}this.addMultipleProductsToCart(n).then((function(e){r.cart&&(r.cart.setActiveElement(document.activeElement),r.cart.renderContents(e));})).catch((function(e){var t;console.error("Error adding products to cart:",e),null===(t=r.errorWrapper)||void 0===t||t.classList.remove("hidden");})).finally((function(){r.addToCartButton.classList.remove("loading"),r.addToCartButton.removeAttribute("aria-disabled"),r.cart&&r.cart.classList.contains("is-empty")&&r.cart.classList.remove("is-empty"),r.addToCartButton.querySelector(".loading__spinner").classList.add("hidden");}));}else console.warn("No products to add to cart");}}},{key:"addMultipleProductsToCart",value:(r=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,a;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r={items:t,sections:this.cart.getSectionsToRender().map((function(e){return e.id})),sections_url:window.location.pathname},e.next=3,fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify(r)});case 3:if((a=e.sent).ok){e.next=6;break}throw new Error("Failed to add products to cart: ".concat(a.status," ").concat(a.statusText));case 6:return e.abrupt("return",a.json());case 7:case"end":return e.stop()}}),e,this)}))),function(e){return r.apply(this,arguments)})},{key:"createProductCardFromTemplate",value:function(e){var t=this.productCardTemplate.content.cloneNode(!0),r=this.data.settings,a=e.featuredImage.aspectRatio||.8,i="".concat(1/a*100,"%"),n="color-".concat(r.cardColorScheme),o=t.querySelector("[data-card-container]"),s=t.querySelector("[data-card-inner]");o.style.setProperty("--ratio-percent",i),s.style.setProperty("--ratio-percent",i),o.classList.add(n),e.featuredImage&&o.classList.add("card--media");var c=t.querySelector("[data-product-image]"),d=t.querySelector("[data-product-link]");e.featuredImage&&e.featuredImage.url&&(c.src=e.featuredImage.url,c.alt=e.featuredImage.alt||e.title,c.width=e.featuredImage.width||600,c.height=e.featuredImage.height||750,d.href=e.url),t.querySelectorAll("[data-product-link-title], [data-product-link-short]").forEach((function(t){t.setAttribute("href",e.url);}));var u=t.querySelector("[data-consumption-advice]"),l=t.querySelector("[data-consumption-advice-text]");e.consumptionAdvice?(l.textContent=e.consumptionAdvice,u.classList.remove("hidden")):u.classList.add("hidden");var b=t.querySelector("[data-product-short-title-wrapper]"),h=t.querySelector("[data-product-short-title]");e.shortTitle?(h.textContent=e.shortTitle,b.classList.remove("hidden")):b.classList.add("hidden");var p=t.querySelector("[data-product-title-wrapper]"),m=t.querySelector("[data-product-title]");e.productTitle?(m.textContent=e.productTitle,p.classList.remove("hidden")):p.classList.add("hidden");var g=t.querySelector("[data-product-reviews]"),f=t.querySelector("[data-reviews-count]");e.reviewsCount>0?(f.textContent=e.reviewsCount,g.classList.remove("hidden")):g.classList.add("hidden");var v=t.querySelector("[data-view-product-link]"),y=t.querySelector("[data-view-product-text]");return v&&y&&(v.href=e.url,y.textContent=r.viewProductText),this.populateBadges(t,e),t}},{key:"populateBadges",value:function(e,t){var r=this.data.settings,a=e.querySelector("[data-product-badge]"),i="";t.available||r.hideSoldoutBadge||!t.badges.soldOut?t.available&&t.badges.sale&&!r.hideSalesBadge?i='<span class="badge badge--bottom-left color-'.concat(r.saleBadgeColorScheme,'">').concat(t.badges.sale,"</span>"):t.available&&t.badges.popular&&!r.hidePopularBadge?i='<span class="badge badge--bottom-left color-'.concat(r.popularBadgeColorSchema,'">').concat(t.badges.popular,"</span>"):t.available&&t.badges.custom&&(i='<span class="badge badge--bottom-left color-'.concat(r.customBadgeColorSchema,'">').concat(t.badges.custom,"</span>")):i='<span class="badge badge--bottom-left color-'.concat(r.soldOutBadgeColorScheme,'">').concat(t.badges.soldOut,"</span>"),i&&(a.innerHTML=i);}},{key:"setupCartUpdateSubscription",value:function(){var e=this;"undefined"!=typeof subscribe&&"undefined"!=typeof PUB_SUB_EVENTS&&(this.cartUpdateUnsubscriber=subscribe(PUB_SUB_EVENTS.cartUpdate,(function(t){e.handleCartUpdate(t);})));}},{key:"handleCartUpdate",value:function(e){var t=this,r=e&&e.cartData;if(r&&r.items){var a=this.getProductsForSelectedBubbles(),i={};r.items.forEach((function(e,t){if(e.properties&&e.properties._routine_id){var r=e.properties._routine_id;i[r]||(i[r]={items:[],giftItem:null,giftItemIndex:null}),i[r].items.push({item:e,index:t+1}),"true"===e.properties._is_gift&&(i[r].giftItem=e,i[r].giftItemIndex=t+1);}})),Object.keys(i).forEach((function(e){var r=i[e];r.items.filter((function(e){return "true"!==e.item.properties._is_gift})).length!==a.length&&r.giftItem&&r.giftItemIndex&&t.removeGiftFromCart(r.giftItemIndex);}));}}},{key:"removeGiftFromCart",value:(t=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,a,i,n;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,r=JSON.stringify({line:t,quantity:0,sections:this.cart.getSectionsToRender().map((function(e){return e.id})),sections_url:window.location.pathname}),e.next=4,fetch("".concat(window.routes.cart_change_url),_objectSpread2(_objectSpread2({},window.fetchConfig()),{body:r}));case 4:if((a=e.sent).ok){e.next=7;break}throw new Error("Failed to remove gift item: ".concat(a.status," ").concat(a.statusText));case 7:return e.next=9,a.text();case 9:i=e.sent,n=JSON.parse(i),this.cart&&(this.cart.setActiveElement(document.activeElement),this.cart.renderContents(n)),e.next=17;break;case 14:e.prev=14,e.t0=e.catch(0),console.error("Error removing gift item from cart:",e.t0);case 17:case"end":return e.stop()}}),e,this,[[0,14]])}))),function(e){return t.apply(this,arguments)})},{key:"setupGlobalListeners",value:function(){var e=this;window.addEventListener("resize",(function(){clearTimeout(e.resizeTimer),e.resizeTimer=setTimeout((function(){e.handleBubbleSlider();}),250);}));}},{key:"handleBubbleSlider",value:function(){if(this.data&&this.data.bubbles){var e=this.mediaQuery.matches;!e&&this.data.bubbles.length>6&&!this.bubbleFlkty?this.bubbleFlkty=new window.Flickity(this.bubblesContainer,{pageDots:!1,prevNextButtons:!0,cellAlign:"left",contain:!0,draggable:!0,groupCells:!0}):e&&this.bubbleFlkty&&(this.bubbleFlkty.destroy(),this.bubbleFlkty=null);}}},{key:"cleanup",value:function(){this.cartUpdateUnsubscriber&&(this.cartUpdateUnsubscriber(),this.cartUpdateUnsubscriber=null);}}],[{key:"generateRoutineId",value:function(){var e=Date.now(),t=Math.random().toString(36).substring(2,15);return "routine_".concat(e,"_").concat(t)}}]),e}();"loading"===document.readyState?document.addEventListener("DOMContentLoaded",(function(){new RoutineBuilder;})):new RoutineBuilder;
})();